export const COMPANY_ID_STORAGE_KEY = "companyID";

function normalizeId(value: unknown): string | null {
  if (!value) return null;
  if (typeof value === "string") return value || null;
  if (typeof value === "object") {
    const record = value as { _id?: string; id?: string };
    const id = record._id || record.id;
    return id ? String(id) : null;
  }
  return null;
}

/** Company id for CompCheck deep links (set on login). */
export function resolveCompanyIdOnLogin(user: Record<string, unknown> | null | undefined): string | null {
  if (!user) return null;

  const role = String(user.role || "").toLowerCase();

  if (role === "company") {
    return normalizeId(user._id ?? user.userId);
  }

  if (role === "employee") {
    return normalizeId(user.companyID ?? user.companyId ?? user.CompanyID);
  }

  return null;
}

export function persistCompanyIdOnLogin(user?: Record<string, unknown> | null): void {
  const companyID = resolveCompanyIdOnLogin(user);

  if (companyID) {
    localStorage.setItem(COMPANY_ID_STORAGE_KEY, companyID);
  } else {
    localStorage.removeItem(COMPANY_ID_STORAGE_KEY);
  }
}
